import React from "react";
import { ThemeProvider } from "@mui/material";
import theme from "../../utils/MUI/generic-override.js";
import "../../styles/common/info-banner.scss";

const InfoBanner = ({
  text = "",
  subtext = "",
  link = "",
  linkText = "",
  postLinkText = "",
  style = "info",
  shouldDisplayBanner,
  useButtonForLink = false,
  textStyles = {},
  buttonAction,
}) => {
  return (
    <ThemeProvider theme={theme}>
      {shouldDisplayBanner() && (
        <div className={`info-banner-container ${style}`}>
          <div className="info-banner-header">
            <i className="fa fa-warning" aria-hidden="true"></i>
            <h3 style={{...textStyles}}>{text}</h3>
          </div>
          {subtext && subtext !== "" && <h4>
            {subtext}
            {!useButtonForLink && (
              <>
              <a href={link} target="_blank">
                {linkText}
              </a>
              {postLinkText}
              </>
            )}
          </h4> }
          {useButtonForLink && (
            <button
              className={`modal-button ${style}`}
              onClick={() => {
                buttonAction()
              }}
            >
              {linkText}
            </button>
          )}
        </div>
      )}
    </ThemeProvider>
  );
};

export default InfoBanner;
